import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Icon } from '@iconify/react';

const TABS = [
    {name:'Teams',icon:<Icon icon="solar:users-group-rounded-bold-duotone" width={20} />,
        link:'/'
    },
    // {name:'Tasks',icon:<Icon icon="solar:checklist-minimalistic-bold-duotone" width={20} />,
    //   link:'/tasks'
    // },
    {name:'Activities',icon:<Icon icon="solar:chart-bold-duotone" width={20} />,
         link:'/analytics'
    },
        {name:'To-Do',icon:<Icon icon="solar:clipboard-check-bold-duotone" width={20} />,
         link:'/todo'
    },
    {name:'Settings',icon:<Icon icon="solar:settings-bold-duotone" width={20} />,
         link:'/settings'
    },
]

const Tabs:React.FC = () => {
  let location = useLocation()

  return (
    <div className='h-20 w-full flex flex-col justify-center  border-t border-gray-200 bg-white'>
       <div className='flex justify-between h-full px-5'>
       {TABS.map((tab)=>(
         <Link to={tab.link} key={tab.name}>
            <div className={`flex flex-col gap-1 mt-2 items-center w-16 rounded-xl py-2 ${location.pathname===tab.link && 'bg-blue-700'} ${location.pathname===tab.link && 'text-white'}`}>
            {tab.icon && tab.icon}
            <button  className={`text-xs`}>{tab.name}</button>
            </div>
        </Link>
       ))}
       </div>
    </div>
  )
}

export default Tabs
